export class Filter {
    constructor(public data: {
        Top?: Number,
        Page?: Number,
        Sort?: { Direction?: Number, SortBy?: String },
        Filter?: {
            Name?: String,
            HasAppointment?: Boolean,
            //Users
            Active?: Boolean,
            //Questionnaries
            GroupID?: Number,
            //Contacts
            AppointmentDateFrom?: String,
            AppointmentDateTo?: String,
            Firstname?: String,
            Lastname?: String,
            Address?: String,
            Settlement?: String,
            Email?: String,
            PhoneNumber?: String,
            UserID?: Number,
            IsRecommendation?: Boolean,
            IsPersonalContact?: Boolean,
            //Appointments
            OfferType?: Number,
            PeriodFrom?: String,
            PeriodTo?: String,
            AreaCode?: String,
            AgentCode?: String,
            AppointmentStatus?: Number,
            BranchOfficeID?: Number,
            Visible?: Boolean,
            AppointmentSource?: Number,
            StatusState?: Boolean,
            Agency?: Boolean,
            //Offer
            OfferNumber?: String,
            InsuranceStartFrom?: String,
            InsuranceStartTo?: String,
            ProductType?: Number,
            Contractor?: String,
            Insuree?: String,
            PaymentFrequency?: Number,
            PremiumRateFrom?: Number,
            PremiumRateTo?: Number,
            SumInsuredFrom?: Number,
            SumInsuredTo?: Number,
            DurationFrom?: Number,
            DurationTo?: Number,
            PaymentType?: Number,
            BranchOfficeIDs?: Array<Number>,
            OfferStatuses?: Array<Number>,
            SignedRemotely?: Boolean,
            //Reports
            DateInsuranceStartFrom?: String,
            DateInsuranceStartTo?: String,
            PaymentTypeID?: Number,
            ProductTypeID?: Number,
            DateRecommendationFrom?: String,
            DateRecommendationTo?: String,
            DateScheduledFrom?: String,
            DateScheduledTo?: String,
            BranchOfficeAppointmentID?: String
        }
    }) { }
}